import apiClient from './apiClient';

const API_URL = '/tramites';

/**
 * Listado "Para cargar Jauregui". Molde: getTramitesParaAprobar (tramiteService).
 *
 * Los filtros van como params sueltos y no en un objeto anidado porque el backend los recibe como
 * @RequestParam, igual que los otros dos listados.
 */
export const getCarpetasJauregui = async (filtros = {}, page = 0, size = 200, texto = '') => {
    const params = { page, size };
    if (texto && texto.trim() !== '') params.texto = texto.trim();
    if (filtros.bloque) params.bloque = filtros.bloque;
    if (filtros.idUsuarioCarga) params.idUsuarioCarga = filtros.idUsuarioCarga;
    if (filtros.estadoPlazo) params.estadoPlazo = filtros.estadoPlazo;
    if (filtros.idTipoTramite) params.idTipoTramite = filtros.idTipoTramite;

    const response = await apiClient.get(`${API_URL}/jauregui`, { params });
    return response.data;
};

/** Los 7 bloques con su etiqueta y si llevan semáforo. No se hardcodean en el frontend. */
export const getBloquesJauregui = async () => {
    const response = await apiClient.get(`${API_URL}/jauregui/bloques`);
    return response.data;
};

/** Los 7 resultados posibles del cálculo, para el selector de la tarjeta. */
export const getResultadosJauregui = async () => {
    const response = await apiClient.get(`${API_URL}/jauregui/resultados`);
    return response.data;
};

/**
 * La carpeta de un trámite, o null si todavía no se pasó a cargar.
 *
 * El backend responde 204 cuando no hay carpeta NI fecha sugerida, y axios deja `data` como string
 * vacío: hay que normalizarlo a null. Cuando no hay carpeta pero sí un turno de VISTA, devuelve
 * `{ fechaPaseSugerida }` — la tarjeta lo usa para proponer la fecha antes de guardar nada.
 */
export const getCargaJauregui = async (idTramite) => {
    const response = await apiClient.get(`${API_URL}/${idTramite}/jauregui`);
    return response.status === 204 || !response.data ? null : response.data;
};

/** Alta y edición desde la tarjeta de la ficha. El listado es solo lectura. */
export const guardarCargaJauregui = async (idTramite, dto) => {
    const response = await apiClient.patch(`${API_URL}/${idTramite}/jauregui`, dto);
    return response.data;
};

/** Saca la carpeta del listado sin tocar el trámite. */
export const quitarCargaJauregui = async (idTramite) => {
    await apiClient.delete(`${API_URL}/${idTramite}/jauregui`);
};

const jaureguiService = {
    getCarpetasJauregui,
    getBloquesJauregui,
    getResultadosJauregui,
    getCargaJauregui,
    guardarCargaJauregui,
    quitarCargaJauregui,
};

export default jaureguiService;
